/**
 * POSTER-AWARD.JS
 * Disables vote button, if no selection is made
 */

export default class PosterAward {
    static init() {
        return new PosterAward();
    }

    constructor() {
        const voteButton = document.querySelector("button.vote-button");
        const posters = document.querySelectorAll('input[type="radio"][name="poster"]')
        
        if (!voteButton) return;
        if (!posters) return;

        posters.forEach((poster) => {
            poster.addEventListener("change", () => {
                voteButton.disabled = false;
            });
        });

    }
}